export function parseIntOrUndefined(value: string = ''): number | undefined {
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? undefined : parsed;
}

export function parseBoolOrUndefined(
  value: string | undefined,
): boolean | undefined {
  if (value === undefined || !['true', 'false'].includes(value.toLowerCase())) {
    return undefined;
  }
  return value.toLowerCase() === 'true';
}
